import React from 'react';
import { useParams } from 'react-router-dom';
import { NewProjectsByStatus } from '../AgentPage/NewProjectsByStatus';


const NewProjectsByStatusWrapper = () => {
  const { status } = useParams();

  // Convert kebab-case to proper format if needed
  const readableStatus = status
    .replace(/-/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());

  return <NewProjectsByStatus projectStatus={readableStatus} />;
};

export default NewProjectsByStatusWrapper;
